import React, { useState } from 'react';
import moment from 'moment/min/moment-with-locales';
import CommentsModal from '../../Components/Modals/commentModal';
import { ListGroup, ListGroupItem, UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Rating } from 'react-simple-star-rating';

const CommentsCard = ({ applicantId, addOrUpdateComment, comments, onDelete }) => {
  const [showCommentsModal, setShowModal] = useState(false);
  const [editComment, setEditComment] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const [comment, setComment] = useState({
    id: 0,
    title: '',
    message: '',
    rating: 0,
  });

  const { t } = useTranslation('translations');

  const handleValidCommentSubmit = (values) => {
    addOrUpdateComment({ ...values, commentMessage: values.messageTextArea, rating: values.commentRating });
    toggleCommentsModal('close', null);
  };

  const toggleCommentsModal = (editOrViewOrCreate, item) => {
    const newState = { id: 0, title: '', message: '', rating: 0 };

    if (item) {
      newState.id = item.id;
      newState.message = item.message;
      newState.title = item.title;
      newState.rating = item.rating;
    }

    setEditComment(editOrViewOrCreate === 'edit' || editOrViewOrCreate === 'create');
    setComment(newState);
    setShowModal(!showCommentsModal);
  };

  const commentListItem = (index, item) => {
    return (
      <ListGroupItem key={index} as="li">
        <div className="popover-header" id="commentHederRow">
          <div className="d-flex justify-content-between align-items-center pb-1">
            <div>{item.title}</div>
            {item?.rating ? <Rating initialValue={item?.rating} size={20} readonly={true} transition /> : null}
          </div>
          <span className="text-sm text-muted text-left">
            {item.userFirstName} {item.userLastName} <i class="fa-regular fa-clock" />
            &nbsp;{moment.utc(item.modified).local().fromNow()}
          </span>
          {isHovered && (
            <div className="float-right">
              <em
                className="fa fa-eye far icon-hover-effect-no-color"
                id={`btnViewComment-${index}`}
                onClick={() => toggleCommentsModal('view', item)}
                style={{ cursor: 'pointer' }}
              />
              <UncontrolledTooltip delay={{ show: 200, hide: 0 }} placement="left" target={`btnViewComment-${index}`}>
                {t('common.VIEW')}
              </UncontrolledTooltip>
              &nbsp;
              <em
                className="fa fa-pencil-alt far icon-hover-effect-no-color"
                id={`btnEditComment-${index}`}
                onClick={() => toggleCommentsModal('edit', item)}
                style={{ cursor: 'pointer' }}
              />
              <UncontrolledTooltip delay={{ show: 200, hide: 0 }} placement="left" target={`btnEditComment-${index}`}>
                {t('common.EDIT')}
              </UncontrolledTooltip>
              &nbsp;
              <em
                id={`btnDeleteComment-${index}`}
                className="fa fa-trash far icon-hover-effect-no-color"
                style={{ cursor: 'pointer' }}
                onClick={() => onDelete(item)}
              />
              <UncontrolledTooltip delay={{ show: 200, hide: 0 }} placement="left" target={`btnDeleteComment-${index}`}>
                {t('common.DELETE')}
              </UncontrolledTooltip>
            </div>
          )}
        </div>
      </ListGroupItem>
    );
  };

  return (
    <div
      className="card card-default d-none d-lg-block"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div>
        {showCommentsModal && (
          <CommentsModal
            showModal={showCommentsModal}
            comment={comment}
            editComment={editComment}
            onToggle={(value) => toggleCommentsModal(value, null)}
            onHandleValidSubmit={handleValidCommentSubmit}
          />
        )}
      </div>
      <div className="card-header">
        <div className="card-title">
          <b>{t('comments.RECENT_COMMENTS')}</b>
          &nbsp;
          {isHovered && (
            <>
              <i
                id="btnCreateNote"
                onClick={() => toggleCommentsModal('create', null)}
                className="fa fa-plus-circle icon-hover-effect fa-lg float-right pt-2"
              ></i>
              <UncontrolledTooltip delay={{ show: 200, hide: 0 }} placement="left" target="btnCreateNote">
                {t('comments.CREATE_NEW_COMMENT')}
              </UncontrolledTooltip>
            </>
          )}
        </div>
      </div>
      <div className="card-body">
        {comments?.length > 0 ? (
          <ListGroup as="ul">{comments.map((item, index) => commentListItem(index, item))}</ListGroup>
        ) : (
          t('comments.NO_COMMENTS_YET')
        )}
      </div>
    </div>
  );
};

export default CommentsCard;
